import React from 'react';
import { Lock } from 'lucide-react';
type CTAButtonProps = {
  className?: string;
  href?: string;
};
export function CTAButton({
  className = '',
  href
}: CTAButtonProps) {
  const isExternal = href?.startsWith('http');
  const linkHref = href || 'https://guiadownload.com/products/digital-product';
  const isAnchor = linkHref.startsWith('#');
  const handleClick = isAnchor ? (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(linkHref);
    el?.scrollIntoView({
      behavior: 'smooth'
    });
  } : undefined;
  return <div className={`flex flex-col items-center ${className}`} data-id="element-132">
      <a href={linkHref} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleClick} className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-dark text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg md:text-xl flex items-center justify-center gap-3 no-underline" data-id="element-133">
        <Lock className="w-5 h-5" data-id="element-134" />
        DESCARGAR MI PLAN AHORA
      </a>
      <p className="mt-3 text-sm text-brand-brown-light flex items-center gap-1.5 font-semibold" data-id="element-135">
        <Lock className="w-3.5 h-3.5" data-id="element-136" /> Pago 100% seguro y encriptado
      </p>
    </div>;
}